if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
        this.resetFlowraZoom();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.setupFlowraGestures();
      }

      showActiveMedia() {
        this.showActiveMediaById(this.openedBy.getAttribute('data-media-id'));
      }

      /**
       * 2026-08-12 (owner: "quero que apareca somente a imagem que foi
       * clicada... apareca as setas... deslizar o dedo"): factored the
       * original showActiveMedia() body out into this id-driven version
       * so prev/next navigation (added below) can reuse the exact same
       * activation logic Dawn already had -- same active-class toggle,
       * same scrollIntoView/scrollLeft centering, same deferred-media
       * YouTube-load trigger. Nothing about how a SINGLE image gets
       * activated changed; only that it can now be triggered by a
       * media id coming from an arrow click / swipe, not just the
       * original opener element.
       */
      showActiveMediaById(mediaId) {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${mediaId}"])`).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        if (container) container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();

        this.currentMediaId = mediaId;
        this.updateFlowraNavVisibility();
        this.resetFlowraZoom();
        this.positionFlowraControls();
        if (activeMedia.tagName === 'IMG' && !activeMedia.complete) {
          activeMedia.addEventListener('load', () => this.positionFlowraControls(), { once: true });
        }
      }

      /**
       * 2026-08-12 (owner: "no desktop, faca as setas e o X de fechar
       * mais perto da imagem"): Dawn's own close button and this
       * file's own arrows both default to viewport-edge positions
       * (`position:fixed; right:2rem` etc.) -- fine when the image
       * fills most of the screen, but once the image is capped to its
       * own aspect ratio (see the max-width/max-height fix above) a
       * wide desktop viewport leaves it much narrower than the screen,
       * stranding the controls far out at the true edges. Repositions
       * all 3 (prev/next/close) from the ACTIVE IMAGE's own measured
       * rect instead of the viewport's, so they always hug the photo
       * itself regardless of its rendered size -- recalculated on
       * every image change (goToFlowraOffset) and on resize/orientation
       * change while the modal is open.
       */
      positionFlowraControls() {
        const img = this.getFlowraActiveImg();
        const prevBtn = this.querySelector('.flowra-modal-nav--prev');
        const nextBtn = this.querySelector('.flowra-modal-nav--next');
        const closeBtn = this.querySelector('.product-media-modal__toggle');
        if (!img) return;
        const rect = img.getBoundingClientRect();
        if (!rect.width || !rect.height) return;
        const GAP = 14;
        const ARROW_SIZE = window.innerWidth <= 480 ? 34 : 40;

        if (prevBtn) {
          prevBtn.style.right = 'auto';
          prevBtn.style.left = Math.max(8, rect.left - GAP - ARROW_SIZE) + 'px';
        }
        if (nextBtn) {
          nextBtn.style.right = 'auto';
          nextBtn.style.left = Math.min(window.innerWidth - ARROW_SIZE - 8, rect.right + GAP) + 'px';
        }
        if (closeBtn) {
          {
            /* 2026-08-12, several follow-ups in a row ("o X deve ficar
               fora da imagem" -> "no desktop ainda esta dentro, coloque
               ao lado" -> "no mobile o X entrou de novo para dentro"):
               neither a single fixed side works at every width. A tall
               portrait photo on desktop is width-constrained, leaving
               a wide horizontal gutter but very little vertical gap
               above it -- "beside" is the only side with real room
               there. On mobile the same photo is often WIDTH-maxed
               (fills nearly the full viewport width), leaving the
               opposite situation: real vertical gap above it but ~0
               horizontal gutter beside it -- "beside" would either
               overlap the image or run off-screen there. Adapts per
               image: prefers beside (this project's own explicit
               desktop preference) whenever there's actually enough
               horizontal room for the full button; falls back to
               above the image otherwise. */
          }
          const closeSize = closeBtn.getBoundingClientRect().width || 40;
          const sideRoom = window.innerWidth - (rect.right + GAP) - closeSize;
          if (sideRoom >= 0) {
            closeBtn.style.left = rect.right + GAP + 'px';
            closeBtn.style.top = Math.max(8, rect.top) + 'px';
          } else {
            closeBtn.style.left = Math.max(8, rect.right - closeSize) + 'px';
            closeBtn.style.top = Math.max(8, rect.top - closeSize - GAP) + 'px';
          }
          closeBtn.style.right = 'auto';
        }
      }

      getFlowraMediaItems() {
        return Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
      }

      goToFlowraOffset(offset) {
        const items = this.getFlowraMediaItems();
        if (items.length < 2) return;
        const currentIndex = items.findIndex((el) => el.getAttribute('data-media-id') === this.currentMediaId);
        const safeCurrent = currentIndex === -1 ? 0 : currentIndex;
        const newIndex = (safeCurrent + offset + items.length) % items.length;
        this.showActiveMediaById(items[newIndex].getAttribute('data-media-id'));
      }

      updateFlowraNavVisibility() {
        const nav = this.querySelector('.flowra-modal-nav-group');
        if (!nav) return;
        nav.hidden = this.getFlowraMediaItems().length < 2;
      }

      getFlowraActiveImg() {
        const active = this.querySelector('.product-media-modal__content > .active');
        if (!active) return null;
        return active.tagName === 'IMG' ? active : active.querySelector('img');
      }

      resetFlowraZoom() {
        this._flowraScale = 1;
        this._flowraTx = 0;
        this._flowraTy = 0;
        const img = this.getFlowraActiveImg();
        if (img) img.style.transform = '';
      }

      /**
       * 2026-08-12 (owner: "apareca as setas... deslizar o dedo na tela
       * para os lados... dar zoom na imagem ampliada deslizando os dois
       * dedos"): single unified touch-gesture handler for the zoom
       * modal -- one finger dragging navigates prev/next (when not
       * already zoomed in) or pans the image (when zoomed in); two
       * fingers pinch to zoom into whatever part of the photo sits
       * between them. Kept as one handler (rather than 3 separate
       * listeners) specifically so a pinch-then-release-to-one-finger
       * sequence doesn't also get misread as a swipe navigation.
       */
      setupFlowraGestures() {
        if (this._flowraGesturesSetup) return;
        this._flowraGesturesSetup = true;

        window.addEventListener('resize', () => {
          if (this.hasAttribute('open')) this.positionFlowraControls();
        });

        const content = this.querySelector('.product-media-modal__content');
        const prevBtn = this.querySelector('.flowra-modal-nav--prev');
        const nextBtn = this.querySelector('.flowra-modal-nav--next');
        if (prevBtn) prevBtn.addEventListener('click', () => this.goToFlowraOffset(-1));
        if (nextBtn) nextBtn.addEventListener('click', () => this.goToFlowraOffset(1));
        if (!content) return;

        const MAX_SCALE = 4;
        const dist = (t1, t2) => Math.hypot(t2.clientX - t1.clientX, t2.clientY - t1.clientY);
        const midpoint = (t1, t2) => ({ x: (t1.clientX + t2.clientX) / 2, y: (t1.clientY + t2.clientY) / 2 });

        let mode = null; // 'swipe' | 'pan' | 'pinch'
        let startX = 0;
        let startY = 0;
        let panOriginX = 0;
        let panOriginY = 0;
        let pinchStartDist = 0;
        let pinchStartScale = 1;

        const applyTransform = () => {
          const img = this.getFlowraActiveImg();
          if (!img) return;
          img.style.transform = `translate(${this._flowraTx}px, ${this._flowraTy}px) scale(${this._flowraScale})`;
        };

        content.addEventListener(
          'touchstart',
          (event) => {
            if (event.touches.length === 2) {
              mode = 'pinch';
              pinchStartDist = dist(event.touches[0], event.touches[1]);
              pinchStartScale = this._flowraScale || 1;
            } else if (event.touches.length === 1) {
              startX = event.touches[0].clientX;
              startY = event.touches[0].clientY;
              if ((this._flowraScale || 1) > 1.02) {
                mode = 'pan';
                panOriginX = this._flowraTx || 0;
                panOriginY = this._flowraTy || 0;
              } else {
                mode = 'swipe';
              }
            }
          },
          { passive: true }
        );

        content.addEventListener(
          'touchmove',
          (event) => {
            if (mode === 'pinch' && event.touches.length === 2) {
              event.preventDefault();
              const d = dist(event.touches[0], event.touches[1]);
              this._flowraScale = Math.min(MAX_SCALE, Math.max(1, pinchStartScale * (d / pinchStartDist)));
              applyTransform();
            } else if (mode === 'pan' && event.touches.length === 1) {
              event.preventDefault();
              this._flowraTx = panOriginX + (event.touches[0].clientX - startX);
              this._flowraTy = panOriginY + (event.touches[0].clientY - startY);
              applyTransform();
            }
          },
          { passive: false }
        );

        content.addEventListener(
          'touchend',
          (event) => {
            if (mode === 'swipe' && event.changedTouches && event.changedTouches.length) {
              const dx = event.changedTouches[0].clientX - startX;
              const dy = event.changedTouches[0].clientY - startY;
              if (Math.abs(dx) >= 40 && Math.abs(dx) >= Math.abs(dy)) {
                this.goToFlowraOffset(dx < 0 ? 1 : -1);
              }
            } else if (mode === 'pinch' && (this._flowraScale || 1) <= 1.02) {
              this.resetFlowraZoom();
            }
            if (!event.touches || event.touches.length === 0) mode = null;
          },
          { passive: true }
        );
      }
    }
  );
}
